import AuthManagement from 'feathers-authentication-management/lib/client';

import feathersClient from './feathersClient-rest';

export const authManagement = new AuthManagement(feathersClient);

export const AnswerService = feathersClient.service('answers');
export const AvatarService = feathersClient.service('avatars');
export const AttachmentService = feathersClient.service('attachments');
export const AudioClipService = feathersClient.service('audio-clips');
export const AuthManagementService = feathersClient.service('authManagement');
export const AvatarSetService = feathersClient.service('avatar-sets');
export const BookingOptionService = feathersClient.service('booking-options');
export const BookingRequestService = feathersClient.service('booking-requests');
export const BookingStatsService = feathersClient.service('booking-stats');
export const ClassAvatarCollectionsService = feathersClient.service('class-avatar-collections');
export const ClassDailyPointsService = feathersClient.service('class-daily-points');
export const ContentLevelingService = feathersClient.service('content-leveling');
export const ContentTagService = feathersClient.service('content-tags');
export const CoreItemService = feathersClient.service('core-item');
export const CoreSentenceService = feathersClient.service('core-sentence');
export const CoreWordService = feathersClient.service('core-word');
export const FeatureFlagService = feathersClient.service('feature-flags');
export const FlashcardService = feathersClient.service('flashcard');
export const InstructorWorkLogService = feathersClient.service('instructors-work-logs');
export const LearnerAttributesService = feathersClient.service('learner-attributes');
export const LessonChangeService = feathersClient.service('lesson-changes');
export const LessonService = feathersClient.service('lessons');
export const LibraryStatsService = feathersClient.service('library-stats');
export const MediaRecordingService = feathersClient.service('media-recordings');
export const NotificationService = feathersClient.service('notifications');
export const OrganizationBookingService = feathersClient.service('organization-booking');
export const OrganizationService = feathersClient.service('organizations');
export const PointMetricsService = feathersClient.service('point-metrics');
export const PresentationService = feathersClient.service('presentation');
export const PresentationBookingService = feathersClient.service('presentation-booking');
export const QACriteriaScoreService = feathersClient.service('qa-criteria-score');
export const QACriteriaService = feathersClient.service('qa-criteria');
export const QuestionService = feathersClient.service('questions');
export const QuestionTagService = feathersClient.service('question-tags');
export const QuizService = feathersClient.service('quizzes');
export const ReviewService = feathersClient.service('reviews');
export const SchoolClassService = feathersClient.service('school-classes');
export const SessionAssessmentResultService = feathersClient.service('session-assessments-results');
export const SessionAssessmentService = feathersClient.service('session-assessments');
export const SessionFlashcardResponseService = feathersClient.service('session-flashcard-response');
export const SlideAssetService = feathersClient.service('slide-asset');
export const SlideService = feathersClient.service('slides');
export const TeachingCardService = feathersClient.service('teaching-card');
export const TopicService = feathersClient.service('topics');
export const TopicTagService = feathersClient.service('topic-tags');
export const TranslationRecordService = feathersClient.service('translation-records');
export const UploadService = feathersClient.service('upload');
export const UsageMetricsService = feathersClient.service('usage-metrics');
export const UserCoreMasteryService = feathersClient.service('user-core-mastery');
export const UserCoreMasteryDailyService = feathersClient.service('user-core-mastery-daily');
export const UserFlashcardService = feathersClient.service('user-flashcard');
export const UserService = feathersClient.service('users');
export const UserSettingsService = feathersClient.service('user-settings');
export const UserSubjectSettingsService = feathersClient.service('user-subject-settings');
export const UserSummaryService = feathersClient.service('user-summary');
export const UserUploadService = feathersClient.service('user-uploads');
export const UserWeeklyPointsService = feathersClient.service('user-weekly-points');
export const VideoRecordingService = feathersClient.service('video-recordings');
export const VocabService = feathersClient.service('vocabs');
export const WritingPadService = feathersClient.service('writing-pads');

export default feathersClient;
